var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 0h50a4 4 0 014 4v56a4 4 0 01-4 4H7a4 4 0 01-4-4V4a4 4 0 014-4z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4h44a3 3 0 013 3v50a3 3 0 01-3 3H10a3 3 0 01-3-3V7a3 3 0 013-3z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16c8.836 0 16 7.163 16 16 0 8.836-7.164 16-16 16-8.837 0-16-7.164-16-16 0-8.837 7.163-16 16-16z",
    fill: "#8FC056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.735 38.537l-5.17-5.169a.8.8 0 010-1.131l1.273-1.272a.8.8 0 011.13 0l3.332 3.331 6.731-6.73a.8.8 0 011.131 0l1.272 1.272a.8.8 0 010 1.13l-8.568 8.57a.8.8 0 01-1.131 0z",
    fill: "#FFF"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9Im5vbmUiIGQ9Ik0wIDBoNjR2NjRIMHoiLz48cGF0aCBkPSJNNyAwaDUwYTQgNCAwIDAgMSA0IDR2NTZhNCA0IDAgMCAxLTQgNEg3YTQgNCAwIDAgMS00LTRWNGE0IDQgMCAwIDEgNC00eiIgZmlsbD0iI0VCRUJFQiIvPjxwYXRoIGQ9Ik0xMCA0aDQ0YTMgMyAwIDAgMSAzIDN2NTBhMyAzIDAgMCAxLTMgM0gxMGEzIDMgMCAwIDEtMy0zVjdhMyAzIDAgMCAxIDMtM3oiIGZpbGw9IiNGRkYiLz48cGF0aCBkPSJNMzIgMTZjOC44MzYgMCAxNiA3LjE2MyAxNiAxNiAwIDguODM2LTcuMTY0IDE2LTE2IDE2LTguODM3IDAtMTYtNy4xNjQtMTYtMTYgMC04LjgzNyA3LjE2My0xNiAxNi0xNnoiIGZpbGw9IiM4RkMwNTYiLz48cGF0aCBkPSJNMjkuNzM1IDM4LjUzN2wtNS4xNy01LjE2OWEuOC44IDAgMCAxIDAtMS4xMzFsMS4yNzMtMS4yNzJhLjguOCAwIDAgMSAxLjEzIDBsMy4zMzIgMy4zMzEgNi43MzEtNi43M2EuOC44IDAgMCAxIDEuMTMxIDBsMS4yNzIgMS4yNzJhLjguOCAwIDAgMSAwIDEuMTNsLTguNTY4IDguNTdhLjguOCAwIDAgMS0xLjEzMSAweiIgZmlsbD0iI0ZGRiIvPjwvZz48L3N2Zz4=";
export { SvgTaskComplete as ReactComponent };